<ng-container *ngFor="let i of rows; index as ii">
    <div class="row">
        <div
            [ngClass]="'col-' + 12 / vil.layout.itemsPerRow"
            *ngFor="let j of i"
        >
            <ng-container *ngIf="ii % 2 === 0">
                <div
                    class="text-center"
                    data-metric
                >
                    {{ j.metric?.shortName }}
                </div>
            </ng-container>

            <ng-container *ngIf="ii % 2 !== 0">
                <div
                    class="insight-chart"
                    [id]="j.id"
                    role="button"
                    data-chart
                    [cmpsTooltipTrigger]="tooltipTpl"
                    [cmpsTooltipTriggerTemplateContext]="j"
                    [cmpsTooltipTriggerCustomTemplate]="true"
                    (click)="onChartClick($event, j)"
                >
                    <ng-chart-arc
                        [options]="j.peerGroup.chartOpts"
                        [data]="j.peerGroup.chartData"
                        *ngIf="peerGroupData"
                    ></ng-chart-arc>
                    <div [ngClass]="{ 'insight-chart-inside': peerGroupData }">
                        <ng-chart-arc
                            [options]="j.chartOpts"
                            [data]="j.chartData"
                        ></ng-chart-arc>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template
    let-ctx="ctx"
    #tooltipTpl
>
    <div
        class="cmps-cdk-text-left"
        cmpsInsightRollover
        [metric]="ctx.metric"
        [viewMetric]="ctx.viewMetric"
        [dataMetric]="ctx.dataMetric"
        [peerGroupDataMetric]="ctx.peerGroup?.dataMetric"
        [showThresholdColours]="showThresholdColours"
        [showTrendArrows]="showTrendArrows"
        [optionalColumns]="optionalColumns"
    ></div>
</ng-template>
